module.exports = __webpack_public_path__ + "Bricked-cf4ad3a7958757d4b18ede206cebc54c.png";